import {saveAs} from 'file-saver';
import {cleanText, dateToFec} from './AccountingFormat';
import {journalsSuffix} from './JournalSelection';

// Colonnes du Fichier des Écritures Comptables (FEC), dans l'ordre imposé par l'administration fiscale
const FEC_COLUMNS = [
    'JournalCode', 'JournalLib', 'EcritureNum', 'EcritureDate', 'CompteNum', 'CompteLib', 'CompAuxNum', 'CompAuxLib',
    'PieceRef', 'PieceDate', 'EcritureLib', 'Debit', 'Credit', 'EcritureLet', 'DateLet', 'ValidDate', 'Montantdevise', 'Idevise'
];

// Montant du FEC : deux décimales, virgule comme séparateur
const fecAmount = value => Number(value || 0).toFixed(2).replace('.', ',');

/**
 * Contenu du FEC : texte tabulé, une ligne par ligne d'écriture, fins de ligne CRLF.
 */
export function buildFec(entries) {
    const lines = [FEC_COLUMNS.join('\t')];
    for (const entry of entries) {
        lines.push([
            entry.journalCode, entry.journalLib, entry.ecritureNum, entry.ecritureDate,
            entry.compteNum, entry.compteLib, entry.compAuxNum, entry.compAuxLib,
            entry.pieceRef, entry.pieceDate, entry.ecritureLib,
            fecAmount(entry.debit), fecAmount(entry.credit),
            entry.ecritureLet, entry.dateLet, entry.validDate, '', ''
        ].map(cleanText).join('\t'));
    }
    return lines.join('\r\n') + '\r\n';
}

// Nom imposé : SIREN + "FEC" + date de clôture (AAAAMMJJ) ; un FEC limité à certains journaux porte leurs codes pour ne pas être pris pour le FEC complet
export function fecFileName(siren, endPeriodDate, journals) {
    return `${siren || '000000000'}FEC${dateToFec(endPeriodDate)}${journals ? `_${journals}` : ''}.txt`;
}

export function downloadFec(exportData, endPeriodDate) {
    const blob = new Blob([buildFec(exportData.entries)], {type: 'text/plain;charset=utf-8'});
    saveAs(blob, fecFileName(exportData.company?.siren, endPeriodDate, journalsSuffix(exportData)));
}
